import { render, staticRenderFns } from "./DisputeRenameAttachmentsModal.vue?vue&type=template&id=2ba243ec"
import script from "./DisputeRenameAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./DisputeRenameAttachmentsModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeRenameAttachmentsModal.vue?vue&type=style&index=0&id=2ba243ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports